export function parseProductImageIds(value?: string): number[] {
  if (!value?.trim()) return [];

  return value
    .split('|')
    .map((part) => part.trim())
    .filter(Boolean)
    .map(Number)
    .filter((id) => Number.isFinite(id) && id > 0);
}

export function formatProductImageIds(ids: number[]): string {
  return ids.join('|');
}

export function isImageUpload(mimetype?: string, filename?: string): boolean {
  if (mimetype?.startsWith('image/')) return true;
  if (!filename) return false;
  return /\.(png|jpe?g|webp|gif|svg)$/i.test(filename);
}
